import Form from "@rjsf/mui";
import validator from "@rjsf/validator-ajv6";
import "./FormDialog.css"

const log = type => console.log.bind(console, type);

export const handleSave = (formId, formData, saveFormData) => {

    // console.log("Save button clicked");

    if (document.getElementById(formId)) {
        document.getElementById(formId)
            .dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    } else {
        saveFormData(formData);
    }
};

export const FormDialog = ({ formId, readOnly, saveFormData, schema, uiSchema, formData, handleFormChange, customValidate }) => {

    const handleSubmit = (formEventData) => {
        let formData = formEventData.formData;
        
        saveFormData(formData);
    };

    if (readOnly) {
        return (
            <Form id={formId}
                formData={formData}
                onSubmit={handleSubmit}
                onError={log("errors")}
                schema={schema}
                uiSchema={uiSchema}
                onChange={handleFormChange}
                validator={validator}
                customValidate={customValidate}
                autoComplete={"off"}
                readonly
            />
        );
    }
    else {
        return (
            <Form id={formId}
                formData={formData}
                onSubmit={handleSubmit}
                onError={log("errors")}
                schema={schema}
                uiSchema={uiSchema}
                onChange={handleFormChange}
                validator={validator}
                customValidate={customValidate}
                autoComplete={"off"}
            />
        );

    }

};
